module.exports = "<md-icon ng-click=\"goBack()\">arrow_back</md-icon>\n<h2 class=\"dash-header\" hide-xs>\n  <span>Profile</span>\n</h2>\n<span flex>\n"